import React, { useEffect } from 'react';
import { TReport } from '../../definitions';
import { reportSchema } from '../components/edit-report/schema';
import { Formik } from 'formik';
import { editReportStyles } from '../components/edit-report/styles';
import EditReport from '../components/edit-report/edit-report';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import store from '../../../../core/redux/store';
import Grid from '@material-ui/core/Grid';
import { CircularProgress } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUsersAction } from '../../../users/presentation/redux/actions/user-actions';
import { getReportAction, setReportAction } from '../redux/actions/reports-actions';
import { updateReportNetwork } from '../../network/update-report.network';

export default function EditReportPage() {
  const classes = editReportStyles();
  const dispatch = useDispatch();

  const state = store.getState();
  const token = state.token.token;

  // @ts-ignore
  const { id } = useParams();
  const { report, loading } = useSelector((state) => state.reports);

  const submit = async (values: TReport) => {
    await updateReportNetwork(token, values);
  };

  useEffect(() => {
    dispatch(setReportAction(id));
  }, []);

  useEffect(() => {
    if (!token) return;

    dispatch(getUsersAction());

    if (!report && id) {
      dispatch(getReportAction(token, id));
    }
  }, [token]);

  return (
    <Grid
      container
      className={classes.root}
      spacing={2}
      direction="column"
      justify="center"
      alignItems="center"
    >
      {report && (
        <BackNavigationComponent
          page={`Report - ${report.name}`}
          uri={`/reports/${report.id}/view`}
          path={[
            { page: 'Home', uri: '/' },
            { page: 'Reports', uri: '/reports' }
          ]}
        />
      )}
      {loading && (
        <Grid container justify="center">
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      )}
      {report && (
        <Formik initialValues={report} validationSchema={reportSchema} onSubmit={submit}>
          {(props) => <EditReport {...props} />}
        </Formik>
      )}
    </Grid>
  );
}
